export default __webpack_public_path__ + "static/media/ticket-unavailable.713e9122.svg";